import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import remember from './remember';
async function getGameSlugs(): Promise<string[]> {
  return remember(`getGameSlugs`, 600, async () => {
    const data = await fetchJsonFromRpgLogsApi(
      `query {
  viewModels {
    gameSlugs
  }
}`
    );

    return data.viewModels.gameSlugs;
  });
}

export default getGameSlugs;
